module.exports = __webpack_public_path__ + "media/images/landing/home/sale_pictures-f1748c3c0758aeaf04a52095d9a5bdfa.png";